import React, { useContext } from 'react';
import SideContentOne from '../../composed/sidecontent/SideContent-One';
import Login from '../../composed/login/Login';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import { Error404 } from '../../composed/error404/Error404';

const LoginPage = () => {
  const { loginAPIResponse } = useContext(SignUpDataContext);
  const { loading, success, message, data } = loginAPIResponse;

  if (success === false && message === 'Network Error') {
    return <Error404 />;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        minHeight: '80vh',
        width: 'auto',
      }}
    >
      <Login />
    </div>
  );
};

export default LoginPage;
